
import { TravelCard } from "../../../components/locations/TravelCard";
import { RajasthanImages } from "../../../media/rajasthan/RajasthanImages";
import PackCard from "../../../components/locations/PackCard";
import contactimg from "../../../media/contactus.png";
import { Link } from "react-router-dom";
import '../MukhaFall/MukhaFall.css';
import { BookSection } from "../../../components/BookSection";


export const NaugarhWaterfall=()=>{
    return (
       <div className="mukha-fall-container">
         <div className="fancy-heading">
           <h1>Naugarh Waterfall</h1>
           <p className="sub-heading">A serene cascade nestled in the lush greenery of Chandauli, perfect for nature enthusiasts and picnickers</p>
         </div>
         <div className="description">
         Located in Chandauli, Uttar Pradesh, Naugarh Waterfall is a hidden gem surrounded by verdant forests and tranquil landscapes. A favorite spot for picnics and outings, this natural marvel offers visitors a refreshing escape from the hustle of daily life. With its pristine waters and serene ambiance, Naugarh Waterfall is a must-visit destination for anyone seeking peace and natural beauty. </div>
         <div className="image-gallery">
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Naugarh Fall/fall.jpg')}
               alt="Mukha Fall 1"
               className="gallery-image"
             />
             {/* <p className="image-caption">The mesmerizing first view of Mukha Fall.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Naugarh Fall/fall1.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           <div className="image-item">
             <img
               src={require('../../../media/tourism/other/Naugarh Fall/fall2.jpg')}
               alt="Mukha Fall 2"
               className="gallery-image"
             />
             {/* <p className="image-caption">A serene close-up of the cascading waters.</p> */}
           </div>
           
          
         </div>
   
         <BookSection />
       </div>
     );
};